<template lang="html">
  <div class="root">
    <input type="text" name="test" value="123e">
  </div>
</template>

<script>
export default {
  data(){
    return {
      msg:'Hello Example'
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Example.vue?19be32ea